import { styled } from '@mui/material/styles';
import { ReactComponent as StarIcon } from 'core/common/assets/images/star.svg';
import { Image } from 'core/common/ui/ui-kit';

export const WingImageStyled = styled(Image)`
  transform: ${({ theme }) => (theme.direction === 'rtl' ? 'scaleX(-1)' : 'none')};
`;

export const WingImageReversedStyled = styled(Image)`
  transform: ${({ theme }) => (theme.direction === 'rtl' ? 'none' : 'scaleX(-1)')};
`;

export const StarIconStyled = styled(StarIcon)`
  flex-shrink: 0;
  width: 16px;
  height: 16px;
`;
